import { Routes } from '@angular/router';
import { authRedirectGuard } from './core/guards/auth-redirect.guard';
import { RegisterComponent } from './features/register/register';
import { UserSettingsComponent } from './features/user-settings/user-settings';

export const routes: Routes = [
	{ path: '', canActivate: [authRedirectGuard], children: [] },

	{
		path: 'user',
		children: [
			{ path: 'settings', component: UserSettingsComponent },
			{ path: '**', redirectTo: 'settings' }
		]
	},

	{ path: 'register', component: RegisterComponent },

	{ path: '**', canActivate: [authRedirectGuard], children: [] }
];
